(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.hcSemanticSearchMoveLogin = {
    attach(context) {
      const body = document.body;
      if (!body || !body.classList.contains('hc-semantic-search-page')) {
        return;
      }

      const loginBlocks = once('hc-move-login', '#block-hc-pleaselogin', context);
      if (!loginBlocks.length) {
        return;
      }

      const summaryEl = document.querySelector('.semantic-search-summary');
      if (!summaryEl) {
        return;
      }

      loginBlocks.forEach((loginBlock) => {
        if (loginBlock && loginBlock.parentNode) {
          // Appends the login block as the last child of .semantic-search-summary
          summaryEl.prepend(loginBlock);
        }
      });
    }
  };
})(Drupal, once);
